/**
 * Basically a pointer to the current play time, along with some extra
 * information. Primarily used for tracking quartiles
 *
 * @param {integer} duration Total video length in seconds.
 * @param {integer} currentTime Elapsed playback time in seconds.
 * @param {[boolean]} quartileReached List that represents which quartiles have been reached.
 */
export default class PlayHeadTracker {
  constructor(duration, currentTime, quartileReached) {
    this.duration = duration;
    this.currentTime = currentTime;
    this.quartileReached = quartileReached;
  }

  /**
   * Set total video length.
   *
   * @param {integer} duration duration of the video
   */
  setDuration(duration) {
    this.duration = duration;
  }

  /**
   * Set elapsed playback time.
   *
   * @param {integer} current time.
   */
  setCurrentTime(currentTime) {
    this.currentTime = currentTime;
  }

  /**
   * Record that a quartile has been reached.
   *
   * @param {integer} q - quartile number.
   * @param {boolean} status - quartile reached status.
   */
  setQuartileReached(q, status) {
    this.quartileReached[q] = status;
  }

  /**
   * Check if a quartile has been reached.
   *
   * @param {integer} q - quartile number.
   */
  getQuartileReached(q) {
    return this.quartileReached[q];
  }

  /**
   * Check if video playback has started.
   */
  hasPlaybackStarted() {
    // TODO
    // When the ad plugin pauses the content before starting the ad playback
    // it was noticed that, in some browsers, 'currentTime' would not be zero.
    // To prevent q0 from being triggered incorrectly, playback is understood
    // as started only when 'currentTime' is greater than 500 milliseconds.
    return this.currentTime > 0.5;
  }

  /**
   * Reset playHeadTracker.
   */
  clear() {
    this.duration = 0;
    this.currentTime = 0;
    this.quartileReached = [false, false, false, false, false];
  }
}



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/events/PlayHeadTracker.js